import { BrowserRouter } from "react-router-dom";
import './App.css';
import RoutesWrapper from "./routes/RoutesWrapper";
import 'react-bootstrap-typeahead/css/Typeahead.css';

function App() {
  return (
    <>
      {/* <Navbar/> */}
      <BrowserRouter>
        <RoutesWrapper />
      </BrowserRouter>
    </>
  );
}

export default App;
